export default __webpack_public_path__ + "static/article-finance-experience-generation-72c3c1e68ba10df94c68ece19eeeaff2.jpg";